import { useTranslation } from 'react-i18next'

import { EntityTabSubTabs } from '../../EntityTabSubTabs'
import {
  getEntityTabRequestsSubTabItems,
  getEntityTabRequestsSubTabQaName,
} from '../EntityTabRequests.utils'

function EntityTabRequestsSubTabs({
  activeSubTab,
  counters,
  subTabOrder,
  onSetActiveSubTab,
}) {
  const { t } = useTranslation()

  const items = getEntityTabRequestsSubTabItems({ counters, subTabOrder, t })

  return (
    <EntityTabSubTabs
      activeValue={activeSubTab}
      getItemQaName={getEntityTabRequestsSubTabQaName}
      items={items}
      onChange={onSetActiveSubTab}
    />
  )
}

export default EntityTabRequestsSubTabs
